/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {FmlxAccordion} from 'fmlx-common-ui';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import {Button, Col, FloatingLabel, Form, Row, Table} from 'react-bootstrap';
import {Get} from '../../lib/Request';
import {API_CONSOLIDATION_DETAIL} from '../../const/Api';
import {EPathname, ERoleId, QUESTION_TYPE, REVIEW_TYPE} from '../../const/dataEnum';
import {showAlert} from '../../lib/utilities';
import LoadingComponent from '../../components/LoadingComponent';
import {ExportToExcel} from '../../components/ExportToExcel';
import {
  exportCsv,
  exportExcel,
  exportPdf,
  exportPdfDetail,
  getMaxScoreByQuestionType,
  importExcel,
  saveConsolidation,
  unlockConsolidationByPeriodIdAndEmployeeId,
} from '../../stores/business/consolidationBusiness';
import {createTempInputElementForUploadingFile} from '../../lib/elementHelper';
import ConsolidationFilter from './ConsolidationFilter';
import ConsolidationKudos from './consolidationKudos';
import MessageApi from '../../api/rest/dropboxMessageApi';
import ActionBarConsolidation from './ActionBarConsolidation';

export default function ConsolidationReview() {
  const dispatch = useDispatch();
  const {userId, authToken, userAuthRoleId} = useSelector((state) => ({
    userId: state.appState.user.id,
    authToken: state.appState.authtoken,
    userAuthRoleId: state.appState.user.authRole?.id,
  }));
  const [reviewList, setReviewList] = useState({});
  const [exportData, setExportData] = useState([]);
  const [loadingEmployee, setLoadingEmployee] = useState(true);
  const [feedback, setFeedback] = useState([]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [isExportExcelLoading, setIsExportExcelLoading] = useState(false);
  const [isExportPdfLoading, setIsExportPdfLoading] = useState(false);
  const [isExportPdfDetailLoading, setIsExportPdfDetailLoading] = useState(false);
  const [isExportExcelRawLoading, setIsExportExcelRawLoading] = useState(false);
  const [isImportExcelLoading, setIsImportExcelLoading] = useState(false);
  const [isExportCsvLoading, setIsExportCsvRawLoading] = useState(false);
  const [dataFirstRender, setDataFirstRender] = useState({});
  // const [filename, setFileName] = useState({});

  const history = useHistory();
  const location = useLocation();
  const employeeID = location.state?.employeeId;
  const periodID = location.state?.currentPeriodId;
  const projectID = location.state?.projectId;
  const isLeaderRoles = [ERoleId.PRACTICE_LEADER, ERoleId.TEAM_LEADER].includes(userAuthRoleId);
  const isAdminRoles = userAuthRoleId === ERoleId.ADMINISTRATOR;
  const pageNo = location.state?.pageNo;
  const pageSize = location.state?.pageSize;
  const lastTotalItem = location.state?.lastTotalItems;
  const lastPageCount = location.state?.lastPageCount;
  const savedFilterMapState = location?.state?.savedFilterMapState;
  // const [selectedFilterConsolidation, setSelectedFilterConsolidation] = useState({
  //   practiceFilter: [],
  //   roleFilter: []
  // })

  useEffect(() => {
    var mounted = true;
    if (!employeeID && !periodID && !projectID) {
      goBack();
    }
    if (mounted) {
      populateData();
      getFeedback();
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  function goBack() {
    history.push({
      pathname: EPathname.CONSOLIDATION,
      state: {
        projectID,
        periodID,
        pageNo,
        pageSize,
        lastTotalItem,
        lastPageCount,
        savedFilterMapState,
      },
    });
  }

  async function populateData() {
    setLoadingEmployee(true);
    let response;
    try {
      response = await Get(`${API_CONSOLIDATION_DETAIL}/${employeeID}/${periodID}`);
      setReviewList(response);
      setDataFirstRender(response);
    } catch (error) {
      let successMessage = 'Data successfully loaded';
      let errorMessage = 'Failed to load data';
      dispatch(showAlert(response, successMessage, errorMessage));
    } finally {
      setLoadingEmployee(false);
    }
  }

  async function getFeedback() {
    setLoadingEmployee(true);
    try {
      const response = await MessageApi.fetchMessageByReceiver(employeeID, periodID);
      setFeedback(response.data || []);
    } catch (error) {
      dispatch(showAlert(error, 'Failed to fetch feedback', 'Failed'));
    } finally {
      setLoadingEmployee(false);
    }
  }

  function updateData(data) {
    let uniqueQuestions = [];
    let titles = [];
    data.forEach((element) => {
      let t = '[' + element?.category + '] ' + element?.title;
      //get unique review question to titles[]
      if (!titles.includes(t)) {
        titles.push(t);
        uniqueQuestions.push({
          genericReviewQuestionID: element?.genericReviewQuestionID,
          skillID: element?.skillID,
          title: element?.title,
          description: element?.description,
          questionType: element?.questionType,
          category: element?.category,
        });
      }
    });
    let exportData = [];
    var dat = uniqueQuestions?.map((element) => {
      let temp = [];
      let totalReviews = 0; // total reviews for this corresponding question
      let totalScore = 0; //total scores from the reviews of this question
      let haveConsolidation = false; // mark if the unique question at least has 1 consolidations on it
      let tempCon = null;

      let temp_t = '[' + element?.category + '] ' + element?.title;
      data.forEach((el) => {
        let data_t = '[' + el?.category + '] ' + el?.title;
        // find a matching consolidation data.el for uniqueQuestions.element
        if (temp_t === data_t) {
          if (el.reviewTypeID === 'cons' && haveConsolidation === false) {
            haveConsolidation = true;
            tempCon = el;
          } else {
            temp.push(el);
            totalReviews += el.score > 0 ? 1 : 0;
            totalScore += el.score;

            exportData.push({
              No: el.rowNumber,
              RevieweeFullName: el?.revieweeFullName,
              ReviewerFullName: el?.reviewerFullName,
              ProjectName: el?.projectName,
              Title: el?.title,
              Description: el?.description,
              Category: el?.category,
              Period: el?.period,
              ReviewType: el?.reviewTypeName,
              ReviewDate: el?.reviewDate,
              Comments: el?.comments,
              Score: el?.score,
            });
          }
        }
      });

      if (!haveConsolidation) {
        //
        let avgScore = totalScore / totalReviews; // average score as the placeholder consolidation score
        temp.push({
          reviewerFullName: 'Final Score',
          reviewTypeName: 'Consolidation',
          reviewTypeID: 'cons',
          score: avgScore === null ? 0 : avgScore,
          comments: '',
        });

        exportData.push({
          No: 'N/A',
          RevieweeFullName: element?.revieweeFullName,
          ReviewerFullName: 'Final Score',
          ProjectName: element?.projectName,
          Title: element?.title,
          Description: element?.description,
          Category: element?.category,
          Period: element?.period,
          ReviewType: element?.reviewTypeName,
          ReviewDate: element?.reviewDate,
          Comments: element?.comments,
          Score: avgScore,
        });
      } else {
        // no consolidation
        temp.push(tempCon);
        exportData.push({
          No: tempCon?.rowNumber,
          RevieweeFullName: tempCon?.revieweeFullName,
          ReviewerFullName: 'Final Score',
          ProjectName: tempCon?.projectName,
          Title: tempCon?.title,
          Description: tempCon?.description,
          Category: tempCon?.category,
          Period: tempCon?.period,
          ReviewType: tempCon?.reviewTypeName,
          ReviewDate: tempCon?.reviewDate,
          Comments: tempCon?.comments,
          Score: tempCon?.score,
        });
        totalReviews += 1;
        totalScore += tempCon?.score;
      }

      return {
        ...element,
        data: temp,
      };
    });
    setExportData(exportData);
    setReviewList(dat);
    setLoadingEmployee(false);
  }

  function updateScore(category, textBoxValue, questionId, questionType, reviewedBy) {
    let maxValue = 0;
    let score = textBoxValue !== '' ? parseFloat(textBoxValue) : '';

    switch (questionType) {
      case QUESTION_TYPE.SCORE_5:
        maxValue = 5;
        break;
      case QUESTION_TYPE.SCORE_10:
        maxValue = 10;
        break;
      case QUESTION_TYPE.SCORE_20:
        maxValue = 20;
        break;
      default:
        maxValue = 4;
        break;
    }

    if (score > maxValue) {
      score = maxValue;
    }

    switch (category) {
      case 'general': {
        setReviewList((prevState) => ({
          ...prevState,
          generalReviews: prevState.generalReviews.map((gr) => {
            if (gr.questionId === questionId) {
              return {
                ...gr,
                answers: gr.answers.map((an) => {
                  if (an.reviewedBy === reviewedBy) {
                    return {
                      ...an,
                      score,
                    };
                  }
                  return an;
                }),
              };
            }

            return gr;
          }),
        }));
        break;
      }
      case 'skill': {
        setReviewList((prevState) => ({
          ...prevState,
          skillReviews: prevState.skillReviews.map((gr) => {
            if (gr.questionId === questionId) {
              return {
                ...gr,
                answers: gr.answers.map((an) => {
                  if (an.reviewedBy === reviewedBy) {
                    return {
                      ...an,
                      score,
                    };
                  }
                  return an;
                }),
              };
            }

            return gr;
          }),
        }));
        break;
      }
      default:
        break;
    }
  }

  function updateNote(category, textBoxValue, questionId, reviewedBy) {
    switch (category) {
      case 'general': {
        setReviewList((prevState) => ({
          ...prevState,
          generalReviews: prevState.generalReviews.map((gr) => {
            if (gr.questionId === questionId) {
              return {
                ...gr,
                answers: gr.answers.map((an) => {
                  if (an.reviewedBy === reviewedBy) {
                    return {
                      ...an,
                      comment: textBoxValue,
                    };
                  }
                  return an;
                }),
              };
            }

            return gr;
          }),
        }));
        break;
      }
      case 'skill': {
        setReviewList((prevState) => ({
          ...prevState,
          skillReviews: prevState.skillReviews.map((gr) => {
            if (gr.questionId === questionId) {
              return {
                ...gr,
                answers: gr.answers.map((an) => {
                  if (an.reviewedBy === reviewedBy) {
                    return {
                      ...an,
                      comment: textBoxValue,
                    };
                  }
                  return an;
                }),
              };
            }

            return gr;
          }),
        }));
        break;
      }
      default:
        break;
    }
  }

  const updateFinalScore = (category, textBoxValue, questionId, questionType) => {
    let maxValue = 0;
    let score = textBoxValue !== '' ? parseFloat(textBoxValue) : '';

    switch (questionType) {
      case QUESTION_TYPE.SCORE_5:
        maxValue = 5;
        break;
      case QUESTION_TYPE.SCORE_10:
        maxValue = 10;
        break;
      case QUESTION_TYPE.SCORE_20:
        maxValue = 20;
        break;
      default:
        maxValue = 4;
        break;
    }

    if (score > maxValue) {
      score = maxValue;
    }

    setReviewList((prevState) => ({
      ...prevState,
      [category]: prevState[category].map((gr) => {
        if (gr.questionId === questionId) {
          return {
            ...gr,
            scoreConsolidation: score,
          };
        }

        return gr;
      }),
    }));
  };

  async function onLockAndSaveClick() {
    setLoadingSave(true);
    const res = await dispatch(saveConsolidation(reviewList, authToken, userId, projectID, true));
    setLoadingSave(false);
    if (res) {
      setReviewList(res);
    }
  }

  async function onSaveClick() {
    setLoadingSave(true);
    const res = await dispatch(saveConsolidation(reviewList, authToken, userId, projectID, false));
    setLoadingSave(false);
    if (res) {
      setReviewList(res);
    }
  }

  const onUnlockClickHandler = async () => {
    setLoadingSave(true);
    const data = await dispatch(unlockConsolidationByPeriodIdAndEmployeeId(periodID, employeeID));
    if (data) {
      setReviewList(data);
    }
    setLoadingSave(false);
  };

  const onExcelClick = async () => {
    setIsExportExcelLoading(true);
    await dispatch(exportExcel(reviewList, authToken, false));
    setIsExportExcelLoading(false);
  };

  const onExcelRawClick = async () => {
    setIsExportExcelRawLoading(true);
    await dispatch(exportExcel(reviewList, authToken));
    setIsExportExcelRawLoading(false);
  };

  const onCsvRawClick = async () => {
    setIsExportCsvRawLoading(true);
    await dispatch(exportCsv(reviewList, authToken, true));
    setIsExportCsvRawLoading(false);
  };

  const onExportPdfClickHandler = async () => {
    setIsExportPdfLoading(true);
    await dispatch(exportPdf(reviewList, authToken));
    setIsExportPdfLoading(false);
  };

  const onExportPdfDetailClickHandler = async () => {
    setIsExportPdfDetailLoading(true);
    await dispatch(exportPdfDetail(reviewList, authToken, userAuthRoleId));
    setIsExportPdfDetailLoading(false);
  };

  const onImportExcelClick = () => {
    createTempInputElementForUploadingFile('.csv', onFileInputChangeHandler);
  };

  const onFileInputChangeHandler = async (e) => {
    setIsImportExcelLoading(true);
    const file = e.target.files[0];
    const data = await dispatch(importExcel(employeeID, periodID, file));
    if (data) {
      setReviewList(data);
    }
    setIsImportExcelLoading(false);
  };

  const review_information = (
    <div className="consolidation-review--review-information">
      <Row style={{marginBottom: 8}}>
        <Col md={4} sm={12}>
          <Form.Group size="lg" className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Reviewer"
              value={loadingEmployee ? '-' : reviewList.employeeName}
              readOnly
              disabled
            />
          </Form.Group>
        </Col>
        <Col md={4} sm={12}>
          <Form.Group size="lg" className="mb-2">
            <Form.Label>Review Period</Form.Label>
            <Form.Control type="text" placeholder="Reviewer" value={reviewList.periodName} readOnly disabled />
          </Form.Group>
        </Col>
        <Col md={4} sm={12}>
          <Form.Group size="lg" className="mb-2">
            <Form.Label>Total Score</Form.Label>
            <Form.Control type="number" placeholder="Total Score" value={reviewList.totalScore} readOnly disabled />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        {isLeaderRoles ? (
          <>
            <Col className="action-bar--consolidation" sm={12} md={8} lg={8}>
              <Button
                size="md"
                className=""
                style={{width: '100px'}}
                disabled={loadingSave || reviewList.length === 0}
                onClick={goBack}
              >
                {loadingSave ? (
                  <div>
                    <span
                      style={{marginLeft: '0px'}}
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                ) : (
                  'Back'
                )}
              </Button>
            </Col>
          </>
        ) : (
          <>
            <ActionBarConsolidation
              onSaveClick={onSaveClick}
              item={reviewList}
              onLockAndSaveClick={onLockAndSaveClick}
              onBackSelected={goBack}
              onUnlockClick={onUnlockClickHandler}
              fallbackComponent={<LoadingComponent />}
            />
            {!loadingEmployee && reviewList.release === true && (
              <Col className="consolidation-review--button-export" sm={12} md={4} lg={4}>
                <ExportToExcel
                  label="Import"
                  variant={'success'}
                  isLoading={isImportExcelLoading}
                  onExcelClick={onImportExcelClick}
                  icon={'Upload'}
                />
                <ExportToExcel
                  label="Export"
                  variant={'success'}
                  isLoading={isExportExcelRawLoading}
                  onExcelClick={onCsvRawClick}
                  icon={'Download'}
                />
                {isAdminRoles ? (
                  <div className="Pdf-container">
                    <ExportToExcel
                      label="PDF Detail"
                      isLoading={isExportPdfDetailLoading}
                      icon={'Download'}
                      variant={'danger'}
                      onExcelClick={onExportPdfDetailClickHandler}
                    />
                    <ExportToExcel
                      label="PDF"
                      isLoading={isExportPdfLoading}
                      icon={'Download'}
                      variant={'danger'}
                      onExcelClick={onExportPdfClickHandler}
                    />
                  </div>
                ) : (
                  <ExportToExcel
                    label="PDF"
                    isLoading={isExportPdfLoading}
                    icon={'Download'}
                    variant={'danger'}
                    onExcelClick={onExportPdfDetailClickHandler}
                  />
                )}
              </Col>
            )}
          </>
        )}
      </Row>
    </div>
  );

  function review_table(data, loading) {
    return (
      <div className="mt-4">
        {loading ? (
          <div className="text-center">
            <LoadingComponent />
          </div>
        ) : data.length === 0 ? (
          <div className="text-center">Nothing to display</div>
        ) : (
          <React.Fragment>
            {data?.generalReviews?.map((review) => (
              <div key={`general-question-${review.questionId}`}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    wordBreak: 'break-word',
                  }}
                >
                  {review.questionTitle}
                </div>
                <div style={{fontSize: '18px', fontWeight: 'bold', wordBreak: 'break-word'}}>{review.title}</div>
                <div style={{fontSize: '14px', wordBreak: 'break-word'}} className="mt-4">
                  {review.questionDescription}
                </div>
                <Table hover className="mb-4 mt-2">
                  <thead>
                    <tr>
                      <th width="*">Name</th>
                      <th width="*">Practice</th>
                      <th width="150">Relation</th>
                      {review.questionType === QUESTION_TYPE.ESSAY ? (
                        <th width="400">Notes</th>
                      ) : (
                        <React.Fragment>
                          <th width="100">Score</th>
                          <th width="400">Notes</th>
                        </React.Fragment>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {review?.answers?.map((answer) => (
                      <React.Fragment key={`answer-general-question-${review.questionId}-${answer.reviewedBy}}`}>
                        <tr>
                          <td>{answer.reviewType === REVIEW_TYPE.CONS.Id ? 'Final Score' : answer.employeeName}</td>
                          <td>{answer.practiceName}</td>
                          <td>{answer.reviewType}</td>
                          {review.questionType === QUESTION_TYPE.ESSAY ? (
                            <></>
                          ) : (
                            <td>
                              <FloatingLabel controlId="floatingTextarea2" label="Score">
                                <Form.Control
                                  type="number"
                                  max={getMaxScoreByQuestionType(review.questionType)}
                                  min={0}
                                  disabled={answer.reviewType !== REVIEW_TYPE.CONS.Id}
                                  onChange={(e) => {
                                    updateScore(
                                      'general',
                                      e.target.value,
                                      review.questionId,
                                      review.questionType,
                                      answer.reviewedBy
                                    );
                                  }}
                                  placeholder="Score"
                                  value={answer?.score ?? ''}
                                />
                              </FloatingLabel>
                            </td>
                          )}
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Notes">
                              <Form.Control
                                as="textarea"
                                disabled={answer.reviewType !== REVIEW_TYPE.CONS.Id}
                                onChange={(e) => {
                                  updateNote('general', e.target.value, review.questionId, answer.reviewedBy);
                                }}
                                placeholder="Notes"
                                style={{height: '100px'}}
                                value={answer?.comment === null ? '' : answer?.comment}
                              />
                            </FloatingLabel>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                    {review.questionType !== QUESTION_TYPE.ESSAY ? (
                      <>
                        <tr key={`final-score-${review.questionId}`}>
                          <td>Final Score</td>
                          <td>Consolidation</td>
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Score">
                              <Form.Control
                                type="number"
                                max={getMaxScoreByQuestionType(review.questionType)}
                                min={0}
                                disabled={reviewList.release}
                                onChange={(e) => {
                                  updateFinalScore(
                                    'generalReviews',
                                    e.target.value,
                                    review.questionId,
                                    review.questionType
                                  );
                                }}
                                placeholder="Score"
                                value={review.scoreConsolidation ?? ''}
                              />
                            </FloatingLabel>
                          </td>
                          <td>
                            <></>
                          </td>
                        </tr>
                      </>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </Table>
              </div>
            ))}
            {data?.skillReviews?.map((review) => (
              <div key={`skill-question-${review.questionId}`}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    wordBreak: 'break-word',
                  }}
                >
                  {review.questionTitle}
                </div>
                <div style={{fontSize: '18px', fontWeight: 'bold'}}>{review.title}</div>
                <div style={{fontSize: '14px'}} className="mt-4">
                  {review.questionDescription}
                </div>
                <Table hover className="mb-4 mt-2">
                  <thead>
                    <tr>
                      <th width="*">Name</th>
                      <th width="*">Practice</th>
                      <th width="150">Relation</th>
                      {review.questionType === QUESTION_TYPE.ESSAY ? (
                        <th width="400">Notes</th>
                      ) : (
                        <React.Fragment>
                          <th width="100">Score</th>
                          <th width="400">Notes</th>
                        </React.Fragment>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {review?.answers?.map((answer) => (
                      <React.Fragment key={`answer-skill-question-${review.questionId}-${answer.reviewedBy}`}>
                        <tr>
                          <td>{answer.employeeName}</td>
                          <td>{answer.practiceName}</td>
                          <td>{answer.reviewType}</td>
                          {review.questionType === QUESTION_TYPE.ESSAY ? (
                            <></>
                          ) : (
                            <td>
                              <FloatingLabel controlId="floatingTextarea2" label="Score">
                                <Form.Control
                                  type="number"
                                  max={getMaxScoreByQuestionType(review.questionType)}
                                  min={0}
                                  disabled={answer.reviewType !== REVIEW_TYPE.CONS.Id}
                                  onChange={(e) => {
                                    updateScore(
                                      'skill',
                                      e.target.value,
                                      review.questionId,
                                      review.questionType,
                                      answer.reviewedBy
                                    );
                                  }}
                                  placeholder="Score"
                                  value={answer?.score ?? ''}
                                />
                              </FloatingLabel>
                            </td>
                          )}
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Notes">
                              <Form.Control
                                as="textarea"
                                disabled={answer.reviewType !== REVIEW_TYPE.CONS.Id}
                                onChange={(e) => {
                                  updateNote('skill', e.target.value, review.questionId, answer.reviewedBy);
                                }}
                                placeholder="Notes"
                                style={{height: '100px'}}
                                value={answer?.comment === null ? '' : answer?.comment}
                              />
                            </FloatingLabel>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                    {review.questionType !== QUESTION_TYPE.ESSAY ? (
                      <>
                        <tr key={`final-score-${review.questionId}`}>
                          <td>Final Score</td>
                          <td>Consolidation</td>
                          <td>
                            <FloatingLabel controlId="floatingTextarea2" label="Score">
                              <Form.Control
                                type="number"
                                max={getMaxScoreByQuestionType(review.questionType)}
                                min={0}
                                disabled={reviewList.release}
                                onChange={(e) => {
                                  updateFinalScore(
                                    'skillReviews',
                                    e.target.value,
                                    review.questionId,
                                    review.questionType
                                  );
                                }}
                                placeholder="Score"
                                value={review.scoreConsolidation ?? ''}
                              />
                            </FloatingLabel>
                          </td>
                          <td>
                            <></>
                          </td>
                        </tr>
                      </>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </Table>
              </div>
            ))}
          </React.Fragment>
        )}
      </div>
    );
  }

  const itemFilterInformation = [
    {
      title: 'Filter Review by :',
      content: <ConsolidationFilter dataFirstRender={dataFirstRender} setReviewList={setReviewList} />,
      disabled: false,
    },
  ];

  return (
    <div className="grid-container">
      <div className="side-panel-container">
        <div className="filterInformation">
          <FmlxAccordion items={itemFilterInformation} id="Filter" />
        </div>
        <div className="kudos-content-container">
          <ConsolidationKudos message={feedback} />
        </div>
      </div>
      <div className="main-content">
        {review_information}
        {review_table(reviewList, loadingEmployee)}
      </div>
    </div>
  );
}
